module.exports = __webpack_public_path__ + "img/earth-medium.b642f650.png";